import { render } from "./NumberFilter.vue?vue&type=template&id=003b2e3c"
import script from "./NumberFilter.vue?vue&type=script&lang=js"
export * from "./NumberFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__